import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';

/**
 * Clase que recibe un formulario y le aplica los metodos Touched(), Dirty(), Pristine() a cada
 * control, para esto utiliza las llaves del mismo, por ultimo recalcula el valor y la validacion del mismo
 * con el updateValueAndValidity().
 */
export class FormUtil {
  /** metodo estatico que recibe por parametro el formulario al cual se le aplicaran las validaciones*/
  static touchControls2(form: FormGroup): void {
    Object.keys(form.controls).forEach((k) => {
      form.get(k)?.markAsTouched();
      form.get(k)?.markAsDirty();
      form.get(k)?.markAsPristine();
      form.get(k)?.updateValueAndValidity({ emitEvent: false });
    });
  }

  /** metodo estatico que recibe por parametro el formulario al cual se le aplicaran las validaciones*/
  static touchControls3(form: FormGroup): void {
    Object.keys(form.controls).forEach((k) => {
      form.get(k)?.markAsTouched();
      form.get(k)?.markAsDirty();
      form.get(k)?.markAsPristine();
      form.get(k)?.updateValueAndValidity();
    });
  }
}

/**
 * Función que aplica los estados Touched, Dirty y Pristine a todos los controles de un formulario.
 * @param form Formulario
 */
export const touchControls = (form: FormGroup): void => {
  Object.keys(form.controls).forEach((k) => {
    form.get(k)?.markAsTouched();
    form.get(k)?.markAsDirty();
    form.get(k)?.markAsPristine();
    form.get(k)?.updateValueAndValidity();
    form.get(k)?.setErrors({ ...form.get(k)?.errors });
  });
};

/**
 * Función que convierte un AbstractControl a FormControl
 * @param abstractControl Elemento de formulario
 * @returns Devuelvel un FormControl del elemento en el parámetro
 */
export const toFormControl = (
  abstractControl: AbstractControl | null | undefined
): FormControl => {
  return abstractControl as FormControl;
};

/**
 * Función que convierte un AbstractControl a FormGroup
 * @param abstractControl Elemento de formulario
 * @returns Devuelvel un FormGroup del elemento en el parámetro
 */
export const toFormGroup = (
  abstractControl: AbstractControl | null | undefined
): FormGroup => {
  return abstractControl as FormGroup;
};

/**
 * Función que convierte un AbstractControl a FormArray
 * @param abstractControl Elemento de formulario
 * @returns Devuelvel un FormArray del elemento en el parámetro
 */
export const toFormArray = (
  abstractControl: AbstractControl | null | undefined
): FormArray => {
  return abstractControl as FormArray;
};
